function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Flex, Icon, icons } from '@tapresearch/ui/components';
import { useDisclosure } from '@tapresearch/ui/hooks';
import { useProjectWaves, useRootQuestionsList } from '../../../../api';
import { OpenFilterButton } from '../../../common/Filter';
import { FilterProvider } from '../../../common/FilterProvider';
import { useGetFilterFromLocation, useUpdateLocationFromFilter } from '../../../hook';
import { ActionButtons } from '../../dashboard/results';
import { LongitudinalFilterBadges } from './LongitudinalFilterBadges';
import { LongitudinalFilterDrawer } from './LongitudinalFilterDrawer';
import { LongitudinalQuestion } from './LongitudinalQuestion';
import { WaveTimelineSelect } from './WaveTimelineSelect';
export var WAVES_VIEW_OPTIONS = {
    all: 'all',
    last4: 'last4',
    last12: 'last12'
};
export var LongitudinalResults = function(param) {
    var projectIdentifier = param.projectIdentifier;
    var defaultFilter = useGetFilterFromLocation({
        filter: {}
    });
    var updateFilter = function(filterValues) {
        setLongitudinalFilter(_object_spread_props(_object_spread({}, longitudinalFilter), {
            filter: filterValues
        }));
    };
    var _useState = _sliced_to_array(useState(defaultFilter), 2), longitudinalFilter = _useState[0], setLongitudinalFilter = _useState[1];
    var _useRootQuestionsList = useRootQuestionsList(projectIdentifier), tmp = _useRootQuestionsList.data, rootQuestionsList = tmp === void 0 ? [] : tmp;
    var _useDisclosure = useDisclosure(), onOpenFilterDrawer = _useDisclosure.onOpen, onCloseFilterDrawer = _useDisclosure.onClose, isOpenFilterDrawer = _useDisclosure.isOpen;
    var _useProjectWaves = useProjectWaves(projectIdentifier, 99999), tmp1 = _useProjectWaves.data, _ref = tmp1 === void 0 ? {} : tmp1, tmp2 = _ref.data, projectWaves = tmp2 === void 0 ? [] : tmp2, isLoading = _useProjectWaves.isLoading;
    var _useMemo = useMemo(function() {
        if (!isLoading && projectWaves) {
            return projectWaves[0].attributes;
        }
        return {
            language_id: undefined,
            country_id: undefined
        };
    }, [
        isLoading,
        projectWaves
    ]), languageId = _useMemo.language_id, countryId = _useMemo.country_id;
    var _useState1 = _sliced_to_array(useState({
        option: WAVES_VIEW_OPTIONS.all,
        ids: []
    }), 2), wavesView = _useState1[0], setWavesView = _useState1[1];
    var currentWavesList = useMemo(function() {
        return projectWaves.filter(function(wave) {
            return wavesView.ids.includes(wave.attributes.providable_id.toString());
        });
    }, [
        wavesView,
        projectWaves
    ]);
    var onChangeWavesView = useCallback(function(value) {
        var _obj;
        var SLICE_SIZE = (_obj = {}, _define_property(_obj, WAVES_VIEW_OPTIONS.all, undefined), _define_property(_obj, WAVES_VIEW_OPTIONS.last4, 4), _define_property(_obj, WAVES_VIEW_OPTIONS.last12, 12), _obj);
        var waveIds = projectWaves.slice(0, SLICE_SIZE[value]).map(function(campaign) {
            return campaign.attributes.providable_id.toString();
        });
        setWavesView(_object_spread_props(_object_spread({}, wavesView), {
            option: value,
            ids: waveIds
        }));
    }, [
        wavesView,
        projectWaves
    ]);
    useEffect(function() {
        if (!!(projectWaves === null || projectWaves === void 0 ? void 0 : projectWaves.length)) {
            setWavesView(function(state) {
                return _object_spread_props(_object_spread({}, state), {
                    ids: projectWaves.map(function(campaign) {
                        return campaign.attributes.providable_id.toString();
                    })
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading
    ]);
    useUpdateLocationFromFilter(longitudinalFilter);
    return /*#__PURE__*/ React.createElement(FilterProvider, {
        defaultFilterValues: defaultFilter['filter'],
        onFilterUpdated: updateFilter
    }, /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "longitudinal-results",
        w: '95%',
        mx: 'auto'
    }, /*#__PURE__*/ React.createElement(ActionButtons, {
        projectIdentifier: projectIdentifier
    }), /*#__PURE__*/ React.createElement(Flex, {
        mt: 4,
        mb: 8,
        justify: "space-between"
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Flex, {
        mb: 2
    }, /*#__PURE__*/ React.createElement(OpenFilterButton, {
        "data-testid": "project-open-filters-button",
        onClick: onOpenFilterDrawer,
        omitFilters: [
            'page',
            'query',
            'sort_by',
            'status'
        ]
    }, /*#__PURE__*/ React.createElement(Icon, {
        mr: "2",
        icon: icons.fi.Filter
    }), " Filter")), /*#__PURE__*/ React.createElement(LongitudinalFilterBadges, {
        onTagClicked: onOpenFilterDrawer
    })), !!(projectWaves === null || projectWaves === void 0 ? void 0 : projectWaves.length) && /*#__PURE__*/ React.createElement(WaveTimelineSelect, {
        waves: projectWaves,
        wavesView: wavesView,
        onChangeWavesView: onChangeWavesView
    })), !!(currentWavesList === null || currentWavesList === void 0 ? void 0 : currentWavesList.length) && rootQuestionsList.map(function(tapQuestion) {
        var identifier = tapQuestion.attributes.identifier;
        return /*#__PURE__*/ React.createElement(LongitudinalQuestion, {
            key: identifier,
            projectIdentifier: projectIdentifier,
            tapQuestion: tapQuestion.attributes,
            waves: currentWavesList
        });
    })), languageId && countryId && /*#__PURE__*/ React.createElement(LongitudinalFilterDrawer, {
        isOpen: isOpenFilterDrawer,
        onClose: onCloseFilterDrawer,
        countryId: countryId,
        languageId: languageId
    }));
};
